import { useMemo } from 'react'
import { useLocation } from '@fs/zion-router'
import { useDSCState } from '../../state/DSCStore'
import getIsTWAMode from '../helpers/twaMode'
import useMediaQuery from './useMediaQuery'
import {
  MOBILE_ACTIVITY_HEADER_MEDIA_QUERY,
  shouldHideGlobalFooter,
  shouldHideGlobalHeader,
  shouldHideGlobalHeaderOnMobile,
} from '../../../globalChromeRoutes'

export default function useLayoutVisibility() {
  const location = useLocation()
  const { showHeader, showFooter, appLayout } = useDSCState()
  const isTwaMode = useMemo(() => getIsTWAMode(), [])

  const hideGlobalFooter = shouldHideGlobalFooter(location?.pathname)
  const isMobileActivityHeaderViewport = useMediaQuery(MOBILE_ACTIVITY_HEADER_MEDIA_QUERY)
  const hideGlobalHeader =
    shouldHideGlobalHeader(location?.pathname) ||
    (isMobileActivityHeaderViewport && shouldHideGlobalHeaderOnMobile(location?.pathname))

  const effectiveShowHeader = !isTwaMode && showHeader && !hideGlobalHeader
  const effectiveShowFooter = !isTwaMode && showFooter && !hideGlobalFooter

  return {
    effectiveShowHeader,
    effectiveShowFooter,
    appLayout,
  }
}
